import { TextField } from "@mui/material";
import { FC } from "react";
import { Control, Controller } from "react-hook-form";

import { CryptorFormData } from "@/pages/cryptor/utils/cryptor.schema";

interface CryptorQuoteFieldProps {
  control: Control<CryptorFormData, {}>;
}

const CryptorQuoteField: FC<CryptorQuoteFieldProps> = ({ control }) => {
  return (
    <Controller
      control={control}
      name="quote"
      render={({ field, fieldState }) => (
        <TextField
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Citation"
          value={field.value}
          onChange={field.onChange}
          margin="normal"
          error={fieldState.invalid}
          fullWidth
        />
      )}
    />
  );
};

export default CryptorQuoteField;
